import { useState } from "react";
import {
  PatientSurgeryByTrackChart,
  PatientSurgeryByAssessmentMadeChart,
} from "../dashboard";

export const PatientSurgeryChartsCard = () => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  const [activeIndex, setActiveIndex] = useState(1);
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <div className="w-full">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeIndex === 1 ? "active" : ""}`}
            aria-current="page"
            onClick={() => setActiveIndex(1)}
          >
            Riesgo de los pacientes
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeIndex === 2 ? "active" : ""}`}
            aria-current="page"
            onClick={() => setActiveIndex(2)}
          >
            Valoración de los pacientes
          </button>
        </li>
      </ul>
      <div className="card">
        <div className="card-body">
          {activeIndex === 1 && <PatientSurgeryByTrackChart />}
          {activeIndex === 2 && <PatientSurgeryByAssessmentMadeChart />}
        </div>
      </div>
    </div>
  );
};
